export default "__VITE_ASSET__36779841__"